/** @format */

import { featuresConstans } from './actions';
import { reducerDebug } from '../../core/debug';

export const FeaturesAction = {
    FEATURES_ACTIVATE_WITH_PARAMETERS: 'FEATURES_ACTIVATE_WITH_PARAMETERS',
};

export function featuresReducers(state = {}, action) {
    reducerDebug('Features reducer: ' + action.type);
    switch (action.type) {
        case featuresConstans.FEATURES_LIST_ACTIVE:
            return {
                type: action.type,
                activeList: action.collections,
            };
        case featuresConstans.FEATURES_GROUP_LIST:
            return {
                type: action.type,
                groupList: action.collections,
            };
        case featuresConstans.FEATURES_POST:
            return {
                type: action.type,
                componentOperation: action.data,
            };
        case featuresConstans.FEATURES_TYPE_BY_GROUP_LIST:
            return {
                type: action.type,
                servicesType: action.collections,
                extraParams: action.extraParams,
            };
        case FeaturesAction.FEATURES_ACTIVATE_WITH_PARAMETERS:
            return {
                ...action,
            };
        default:
            return {
                ...state,
                ...action,
            };
    }
}
